import React from 'react';
import { Box, TextV2, ButtonV2, CloseButton } from '@withjoy/joykit';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import type { WebsiteBannerProps } from './WebsiteBanner.types';
import { pxToRem } from '@withjoy/joykit/theme';
import { WEBSITE_BANNER_HEIGHT_DESKTOP, WEBSITE_BANNER_HEIGHT_MOBILE } from './WebsiteBanner.constants';

const WebsiteBanner: React.FC<WebsiteBannerProps> = ({ message, actionButton, onClose }) => {
  const isMobile = useIsMobileScreen();

  const displayMessage = (isMobile && message.mobile) || message.default;
  const displayButtonLabel = isMobile && actionButton?.label.mobile ? actionButton.label.mobile : actionButton?.label.default;

  return (
    <Box
      display="flex"
      backgroundColor="newUIBrandPrimary"
      width="100%"
      zIndex="banner"
      position="fixed"
      top={0}
      alignItems="center"
      justifyContent="center"
      paddingLeft={5}
      height={{ _: WEBSITE_BANNER_HEIGHT_MOBILE, md: WEBSITE_BANNER_HEIGHT_DESKTOP }}
      paddingRight={{ _: 7, md: 5 }}
      paddingY={5}
      gap={{ _: 2, md: 4 }}
    >
      <TextV2
        typographyVariant={{ _: 'label2', md: 'label3' }}
        color="white"
      >
        {displayMessage}
      </TextV2>
      {actionButton && (
        <ButtonV2
          flexShrink={0}
          variant="outline"
          shape="rounded"
          typographyVariant={{ _: 'button1', md: 'button2' }}
          intent="primary"
          _hover={{ color: 'white', borderColor: 'white' }}
          _active={{ color: 'white', borderColor: 'white' }}
          height="fit-content"
          onClick={actionButton?.onClick}
          paddingX={{ _: 4, md: 5 }}
          paddingY={{ _: pxToRem(7), md: pxToRem(10) }}
          color="white"
          borderColor="white"
          loading={actionButton?.loading}
        >
          {displayButtonLabel}
        </ButtonV2>
      )}
      {onClose && (
        <CloseButton
          position="absolute"
          color="white"
          right={{ _: -16, md: 6 }}
          onClick={onClose}
        />
      )}
    </Box>
  );
};

WebsiteBanner.displayName = 'WebsiteBanner';

export { WebsiteBanner };
